export default __webpack_public_path__ + "static/media/maduro-3Open.b0d676ab.jpg";